/**
 * Formats percentage with conditional decimal places
 * Removes .00 if the percentage is a whole number
 */
export const formatPercentage = (value: number): string => {
  const formatted = value.toFixed(2);
  const valueWithoutDecimal = formatted.endsWith(".00")
    ? formatted.slice(0, -3)
    : formatted;
  return valueWithoutDecimal + "%";
};
